import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initEmployees } from '../../actions/employeesActions';
import { initProjects } from '../../actions/projectsActions';
import { initProjectcategories } from '../../actions/projectcategoriesActions';
import { initNews } from '../../actions/newsActions';
import { initServices } from '../../actions/servicesActions';
import { initSiteOptions } from '../../actions/siteActions';
import { initPages } from '../../actions/pagesActions';

// eslint-disable-next-line
import logo from '../../logo.svg';
import Frontpage from '../frontpage/frontpage';
import Projects from '../projects/projects';
import Project from '../project/project';
import Newsitem from '../newsitem/newsitem';
import Employees from '../employees/employees';
import FourOhFour from '../fourohfour/fourohfour';
import News from '../news/news';
import Page from '../page/page';
import Services from '../services/services';
import Service from '../service/service';
import Contact from '../contact/contact';

import Loader from '../loader/loader';

import has from 'lodash.has';

import {BrowserRouter, Route, Switch} from 'react-router-dom';

import "normalize.css";
import './app.css';
import {Helmet} from "react-helmet";

class App extends Component {

    constructor(props) {
        super(props);
        this.initData = this.initData.bind(this);
    }

    componentDidMount() {
        this.initData();
    }


    initData() {
        this.props.dispatch(initEmployees());
        this.props.dispatch(initProjects());
        this.props.dispatch(initNews());
        this.props.dispatch(initProjectcategories());
        this.props.dispatch(initServices());
        this.props.dispatch(initSiteOptions());
        this.props.dispatch(initPages());
    }

  render() {
        if (false === this.props.loaded) {
            return (<Loader/>);
        }

        return (
          <BrowserRouter>
              <div className="kwootsite">
                  <Helmet>
                      <title>KWOOT</title>
                  </Helmet>
                <Switch>
                  <Route exact path="/" component={Frontpage} />
                  <Route exact path="/ons-werk" component={Projects} />
                  <Route path="/project/:projectslug" component={Project} />
                  <Route exact path="/actueel" component={News} />
                  <Route path="/actueel/:newsitemslug" component={Newsitem} />
                  <Route exact path="/diensten" component={Services} />
                  <Route path="/dienst/:serviceslug" component={Service} />
                  <Route path="/pagina/:pageslug" component={Page} />
                  <Route
                    exact
                    path="/de-mensen-van-kwoot"
                    component={Employees}
                  />
                  <Route exact path="/contact" component={Contact} />
                  <Route component={FourOhFour} />
                </Switch>
              </div>
          </BrowserRouter>
        );

  }
}

const mapStateToProps = (store) => {
    const loaded = (
        has(store, 'employees.employees') &&
        has(store, 'projects.projects') &&
        has(store, 'news.news') &&
        has(store, 'projectcategories.projectcategories') &&
        has(store, 'services.services') &&
        has(store, 'site')
    );

    return {
        loaded: loaded
    }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/app/app.js